angular.module('app').factory('LoginFactory',
    ['AprimaRestangular', '$q', 'Bridge', 'LocalStorageRepository', 'VersionService', '$log', 'ServerInfoRepository', 'aprgettext','PatientSettingsService', 'SessionService','DashboardService', 'PatientPortalStorageRepository', 'AprimaCache',
        function (AprimaRestangular, $q, Bridge, LocalStorageRepository, VersionService, $log, ServerInfoRepository, gettext, PatientSettingsService, SessionService, DashboardService, PatientPortalStorageRepository, AprimaCache) {
            'use strict';

            var loginErrorCodes = {
                UnknownError: 1,
                InvalidRequest: 2,
                UnknownClientId: 4,
                LoginFailed: 8,
                NotMobileUser: 16,
                InactiveUser: 32,
                NotAllowedToLogin: 64,
                PrmVersionUnsupported: 128,
                MultipleUserAccounts: 256,
            };

            function updateVersionInfo(userLoginInfo) {
                if (userLoginInfo && userLoginInfo.ProductVersions) {
                    if (userLoginInfo.ProductVersions.PrmAssemblyVersion) {
                        ServerInfoRepository.setPrmAssemblyVersion(userLoginInfo.ProductVersions.PrmAssemblyVersion);
                    }
                    if (userLoginInfo.ProductVersions.PrmDatabaseVersion) {
                        ServerInfoRepository.setPrmDatabaseVersion(userLoginInfo.ProductVersions.PrmDatabaseVersion);
                    }
                    if (userLoginInfo.ProductVersions.PrmDatabaseBuild) {
                        ServerInfoRepository.setPrmDatabaseBuild(userLoginInfo.ProductVersions.PrmDatabaseBuild);
                    }
                    if (userLoginInfo.ProductVersions.AppServiceVersion) {
                        ServerInfoRepository.setMobileAssemblyVersion(userLoginInfo.ProductVersions.AppServiceVersion);
                    }
                    if(userLoginInfo.SupportedFeatures) {
                        ServerInfoRepository.setSupportedFeatures(userLoginInfo.SupportedFeatures);
                    }
                }
            }

            var postStatementsLogin = function (clientURL, _clientId, _birthdate, _zipcode, _accessCode, _phoneNumber, clientFeatures) {

                var restangular = AprimaRestangular.get('patient');

                return restangular.one('statements-login').customPOST({
                    BirthDate: _birthdate,
                    ZipCode: _zipcode,
                    ClientId: _clientId,
                    DeviceId: LocalStorageRepository.getDeviceId(),
                    AccessCode: _accessCode,
                    PhoneNumber: _phoneNumber,
                    ClientFeatures : clientFeatures
                })
                    .then(function (userLoginInfo) {
                        var authToken = userLoginInfo.JsonWebToken,
                            msg;

                        return VersionService.checkVersions(userLoginInfo).then(function (validationSuccesful) {
                            if (validationSuccesful === false) {
                                return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                            }

                            if (!userLoginInfo) {
                                msg = gettext('Unexpected null result from server in Login');
                            }
                            else if (!userLoginInfo.DeviceId) {
                                return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                            }

                            if (msg) {
                                $log.warn(msg);
                                Bridge.trackException(msg);
                            }

                            AprimaCache.Lists.removeAll();
                            LocalStorageRepository.clearKeysOfType('metadata');

                            LocalStorageRepository.setDeviceId(userLoginInfo.DeviceId);
                            LocalStorageRepository.setJsonWebToken(authToken);
                            LocalStorageRepository.setBirthDate(_birthdate);
                            LocalStorageRepository.setUserFullName(userLoginInfo.FirstName + ' ' + userLoginInfo.LastName);
                            LocalStorageRepository.setUserID(userLoginInfo.Id);
                            LocalStorageRepository.setIsPatient(userLoginInfo.IsPatient);
                            LocalStorageRepository.setAccessCode(_accessCode);

                            updateVersionInfo(userLoginInfo);

                            PatientPortalStorageRepository.setResponsibleParties(userLoginInfo.ResponsibleParties);

                            SessionService.setPracticeConsentAccepted(userLoginInfo.IsPracticeConcentAccepted);
                            SessionService.setNewPasswordRequired(userLoginInfo.IsNewPasswordRequired);

                            var featuresPromise = PatientSettingsService.loadPatientFeatures();
                            var dashboardPromise = DashboardService.loadPatientDashboardFeatures();
                            return $q.all([featuresPromise, dashboardPromise]);
                        }, function () {
                            return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                        });
                    }, function (response) {
                        updateVersionInfo(response.data);

                        var msg = gettext('login error');

                        return  $q.reject(new Error(msg));

                    });
            };

            var loginSuccess = function(userLoginInfo) {
                var authToken = userLoginInfo.JsonWebToken,
                    msg;

                return VersionService.checkVersions(userLoginInfo).then(function (validationSuccesful) {
                    if (validationSuccesful === false) {
                        return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                    }

                    if (!userLoginInfo) {
                        msg = gettext('Unexpected null result from server in Login');
                    }
                    else if (!userLoginInfo.DeviceId) {
                        return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                    }

                    if (msg) {
                        $log.warn(msg);
                        Bridge.trackException(msg);
                    }

                    AprimaCache.Lists.removeAll();
                    LocalStorageRepository.clearKeysOfType('metadata');

                    LocalStorageRepository.setDeviceId(userLoginInfo.DeviceId);
                    LocalStorageRepository.setJsonWebToken(authToken);
                    LocalStorageRepository.setUserName(userLoginInfo.Username);
                    LocalStorageRepository.setUserFullName(userLoginInfo.FirstName + ' ' + userLoginInfo.LastName);
                    LocalStorageRepository.setUserID(userLoginInfo.Id);
                    LocalStorageRepository.setIsPatient(userLoginInfo.IsPatient);
                    LocalStorageRepository.setIdentityHint(userLoginInfo.IdentityHint);

                    updateVersionInfo(userLoginInfo);

                    PatientPortalStorageRepository.setResponsibleParties(userLoginInfo.ResponsibleParties);
                    PatientPortalStorageRepository.setIsAccountResponsiblePartyForPatient(userLoginInfo.IsAccountResponsiblePartyForPatient);

                    if (userLoginInfo.IsPatient) {
                        PatientPortalStorageRepository.setActivePatient(userLoginInfo.Id, userLoginInfo.FirstName, userLoginInfo.LastName, userLoginInfo.IsPatient);
                    } else {
                        var responsiblePartyPatient = PatientPortalStorageRepository.getActiveResponsibleParty();
                        if (responsiblePartyPatient) {
                            PatientPortalStorageRepository.setActivePatient(responsiblePartyPatient.Id, responsiblePartyPatient.FirstName, responsiblePartyPatient.LastName, responsiblePartyPatient.IsPatient);
                        } else {
                            return $q.reject(new Error(gettext('Username is not associated with a patient.')));
                        }
                    }

                    SessionService.setPracticeConsentAccepted(userLoginInfo.IsPracticeConcentAccepted);
                    SessionService.setNewPasswordRequired(userLoginInfo.IsNewPasswordRequired);

                    var featuresPromise = PatientSettingsService.loadPatientFeatures();
                    var dashboardPromise = DashboardService.loadPatientDashboardFeatures();
                    return $q.all([featuresPromise, dashboardPromise]);
                }, function () {
                    return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                });
            };

            var loginFailure = function(response, _clientId) {
                updateVersionInfo(response.data);

                var msg = gettext('login error'),
                    errorCode = null;
                if (response.status === 401) {
                    msg = gettext('Invalid username or password');

                    errorCode = angular.isNumber(response.data.ErrorCode) ? response.data.ErrorCode : 0;

                    if (errorCode & loginErrorCodes.UnknownClientId) {
                        msg = gettext('Unknown clientId (' + _clientId + ').');
                    } else if (errorCode & loginErrorCodes.LoginFailed) {
                        msg = gettext('Invalid username or password');
                    } else if (errorCode & loginErrorCodes.InactiveUser) {
                        msg = gettext('This user account is not active and cannot login.');
                    } else if (errorCode & loginErrorCodes.PrmVersionUnsupported) {
                        msg = gettext('PRM version out of date.  Please contact customer support about upgrading.');
                    }
                }

                return $q.reject(new Error(msg));
            };

            var postLogin = function (clientURL, _clientId, _username, _password, userId, clientFeatures) {

                var restangular = AprimaRestangular.get('patient');

                return restangular.one('login').customPOST({
                    Username: _username,
                    Password: _password,
                    ClientId: _clientId,
                    DeviceId: LocalStorageRepository.getDeviceId(),
                    UserId : userId,
                    ClientFeatures : clientFeatures
                })
                    .then(function (userLoginInfo) {
                        return loginSuccess(userLoginInfo, clientURL);
                    }, function (response) {
                        return loginFailure(response, _clientId);
                    });
            };

            
            var postTokenLogin = function (clientURL, _clientId, token) {
                var restangular = AprimaRestangular.get('patient');

                return restangular.one('token-login').customPOST({}, '', { token: token }, {})
                    .then(function (userLoginInfo) {
                        return loginSuccess(userLoginInfo, clientURL);
                    }, function (response) {
                        return loginFailure(response, _clientId);
                    });
            };



            var postIdentityTokenLogin = function (clientURL, _clientId, token, clientFeatures) {
                var restangular = AprimaRestangular.get('patient');

                return restangular.one('identity-authorize').customPOST(
                    {
                        Token: token, 
                        ClientId: _clientId, 
                        DeviceId: LocalStorageRepository.getDeviceId(), 
                        ClientFeatures: clientFeatures
                    })
                    .then(function (userLoginInfo) {
                        return loginSuccess(userLoginInfo, clientURL);
                    }, function (response) {
                        return loginFailure(response, _clientId);
                    });
            };

            var callPARRedirectUrl = function(username, _clientId) {
                var restangular = AprimaRestangular.get('patient');

                return restangular.one('par?username='+username+'&clientId='+ _clientId).customPOST({}).then(
                    function(response) {
                        console.log('PAR Response:', response);
                        return response;
                    },
                    function(error) {
                        console.error('PAR Call Error:', error);
                        throw error;
                    }
                );
            };

            var postRouteUsername = function (clientId, username) {

                var restangular = AprimaRestangular.get('patient');

                return restangular.one('route-username').customPOST({
                    Username: username,
                    ClientId: clientId,
                });
            };

            var postRegister = function (clientId, username, password, clientFeatures) {

                var restangular = AprimaRestangular.get('patient');

                return restangular.one('register').customPOST({
                    Username: username,
                    Password: password,
                    ClientId: clientId,
                    DeviceId: LocalStorageRepository.getDeviceId(),
                    ClientFeatures : clientFeatures
                });
            };

            var postConfirm = function (clientId, personId, dateOfBirth, emailAddress, username) {

                var restangular = AprimaRestangular.get('patient');

                return restangular.one('confirm?clientId=' + clientId).customPOST({
                    PersonUid: personId,
                    DateOfBirth: dateOfBirth,
                    EmailAddress: emailAddress,
                    Username: username
                });
            };

            var callIdentityLogoutRedirectUrl = function(clientId){
                var restangular = AprimaRestangular.get('patient');
                return restangular.one('identity-logout?clientId=' + clientId).customPOST({}).then(
                    function(response) {
                        console.log('Identity Logout Url Call Response:', response);
                        return response;
                    },
                    function(error) {
                        console.error('Identity Logout Url Call Error:', error);
                        throw error;
                    }
                );
            };

            return {
                postLogin: postLogin,
                postTokenLogin: postTokenLogin,
                postStatementsLogin: postStatementsLogin,
                postIdentityTokenLogin: postIdentityTokenLogin,
                postRouteUsername: postRouteUsername,
                callPARRedirectUrl: callPARRedirectUrl,
                callIdentityLogoutRedirectUrl: callIdentityLogoutRedirectUrl,
                postRegister: postRegister,
                postConfirm: postConfirm
            };

            
        }]);
